import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  gap: 20px;
`

export const SubContainer = styled(Container)`
  padding: 0px;
`

export const HorizontalLine = styled.span`
  width: 100%;
  height: 1px;
  background-color: #0000001A;
  margin: 5px 0px;
`

export const Form = styled.form`
  width: 880px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  padding: 12px;
  background-color: #F7F7F7;
  box-shadow: 0px 2px 10px -6px #252525;
  gap: 12px;
`

export const Info = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
`

export const FormField = styled(Container)`
  min-width: 200px;
  flex: ${props => props.stretch ? props.stretch : 1};
  justify-content: flex-end;
  padding: 0px;
  gap: 5px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  margin-bottom: 15px;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
`

export const TextRow = styled(Row)`
  align-items: center;
  margin-bottom: 0px;
  gap: 7px;

  p {
    margin: 0px;
  }
`

export const StepRow = styled.div`
  width: 400px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: flex-start;
  position: relative;
`

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
`

export const StepLabel = styled.p`
  color: #999999;
  font-size: 11px;
  line-height: 14px;
  text-align: center;
  margin: 0px;
`

export const StepCircle = styled.div`
  z-index: 2;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 99px;
  background-color: ${({ step, currentStep }) => (
    currentStep?.number > step?.number
      ? '#44CF6C'
      : currentStep?.number === step?.number ? '#FFC100' : '#252525'
  )};

  p {
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 1px;
  }
`

export const StepLine = styled.span`
  display: inline-block;
  position: absolute;
  top: 14px;
  left: 60px;
  width: ${({ currentStep }) => currentStep * 140}px;
  height: 3px;
  z-index: 1;
  background-color: #44CF6C;
  transition: width 0.3s;
`

export const AddressContainer = styled.div`
  position: relative;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 18px;
  margin: 0px;
`

export const Label = styled.p`
  color: #777777;
  font-size: 14px;
  text-align: center;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const WarningText = styled.p`
  color: #FF3939;
  font-size: 14px;
  text-align: center;
  margin: 0px;
`

export const MoneyText = styled(NumericFormat).attrs (props => {
  return {
    value: props.value.toFixed (2).replace ('.', ','),
    thousandSeparator: '.',
    decimalSeparator: ',',
    displayType: 'text',
    prefix: 'R$ '
  }
})`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 1px;
`

export const ErrorContainer = styled.div`
  padding: 8px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  color: #FFFFFF;
  background-color: #FF3939;
`
